const ICON_THEME_MODE = {
  DEFAULT: 'default',
  CUSTOM: 'custom',
  INVERT: 'invert',
} as const;

export const ICON_THEME_MODES = [
  ICON_THEME_MODE.DEFAULT,
  ICON_THEME_MODE.CUSTOM,
  ICON_THEME_MODE.INVERT,
] as const;

export const DEFAULT_ICON_THEME_COLOR = '#2554C7';

function normalizeHexColor(value: unknown) {
  const compact = String(value || '')
    .trim()
    .replace(/\s/g, '')
    .toUpperCase();
  if (!compact) return null;
  const withHash = compact.startsWith('#') ? compact : `#${compact}`;
  return /^#[0-9A-F]{6}$/.test(withHash) ? withHash : null;
}

export function mixWithWhite(hex: string, ratio: number) {
  const normalized = normalizeHexColor(hex);
  if (!normalized) return null;

  const clean = normalized.slice(1);
  const r = parseInt(clean.slice(0, 2), 16);
  const g = parseInt(clean.slice(2, 4), 16);
  const b = parseInt(clean.slice(4, 6), 16);
  const mix = (channel: number) =>
    Math.round(channel + (255 - channel) * ratio)
      .toString(16)
      .padStart(2, '0')
      .toUpperCase();

  return `#${mix(r)}${mix(g)}${mix(b)}`;
}

/**
 * Accordion icon colors persisted on empresa-banner (`temaIconos` / `colorTemaIconos`).
 * `null` leaves each icon's default CSS (per-section palette).
 */
export function getIconThemeTileStyle(mode: string | null | undefined, color: string | null | undefined) {
  const hex = normalizeHexColor(color) || DEFAULT_ICON_THEME_COLOR;
  if (mode === ICON_THEME_MODE.CUSTOM) {
    return { background: mixWithWhite(hex, 0.88), color: hex };
  }
  if (mode === ICON_THEME_MODE.INVERT) {
    return { background: hex, color: mixWithWhite(hex, 0.62) };
  }
  return null;
}

export function normalizeIconTheme(source: Record<string, unknown> | null | undefined) {
  const allowed = new Set<string>(ICON_THEME_MODES);
  const mode = (source?.temaIconos || source?.iconThemeMode) as string | undefined;
  const color =
    normalizeHexColor(source?.colorTemaIconos || source?.iconThemeColor) || DEFAULT_ICON_THEME_COLOR;

  return {
    mode: allowed.has(mode || '') ? mode : ICON_THEME_MODE.DEFAULT,
    color,
  };
}

export { ICON_THEME_MODE };
